// Configuración centralizada
const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  isDevelopment: process.env.REACT_APP_ENV === 'development',
  tokenKey: 'psych_app_token',
  userKey: 'psych_app_user',
  sessionTypes: {
    SESSION_30: '30_minutes',
    SESSION_45: '45_minutes',
    PACK_4: 'pack_4_sessions'
  },
  sessionLabels: {
    '30_minutes': 'Sesión 30 min',
    '45_minutes': 'Sesión 45 min',
    'pack_4_sessions': 'Pack 4 sesiones'
  }
};

export default config;
